export default "__VITE_ASSET__fJw4jnBI__"